<app-nav></app-nav>


<div class="container mt-2 mb-2 pt-5 pb-5">
    <div class="row ">
        <div class="col-5 border-right border-dark">
            <h1>Ваш персональний <br>AI &ndash; асистент</h1>
            <p>Якщо вам тривожно, ви відчуваєте що вигоріли, чи просто хочете краще зрозуміти себе – Anima тут, щоб
                допомогти.</p>
            <ul class="features">
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Проходьте тести на основі нейронауки: на тривожність, стрес, вигорання чи депресію
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Спілкуйтесь із AI &ndash; асистентом, що навчений на найбільш сучасних дослідженнях
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Аналізуйте свій стан за допомогою відстеження погляду
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Виявляйте ранні ознаки емоційного виснаження
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Отримуйте персоналізовані науково обґрунтовані рекомендації
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Залишайтеся повністю конфіденційними
                </li>

            </ul>
        </div>
        <div class="col-7 pt-4 pb-4 d-flex justify-content-end">
            <div class="pricing-wrapper">
                <h3 class="mb-4">Почніть свою подорож з Anima</h3>
                <div class="border border-primary pt-4 pb-4 pl-3 pr-3 mb-4">
                    <div class="d-flex justify-content-between align-items-center w-100 mb-3">
                        <h3 class="">Доступ до AI &ndash; асистента</h3>
<!--                        <h3 class="highlight">0₴</h3>-->
                    </div>
                    <p class="text-primary">
                        Anima допомагає зрозуміти ваш психічний стан всього за кілька хвилин — із персоналізованою
                        підтримкою від унікального AI &ndash; асистента, створеного на основі нейронауки.
                        Щоденні інсайти допоможуть краще справлятися зі стресом, тривожністю та вигоранням.
                        А також – отримаєте доступ до розширених тестів на вигорання, депресію та емоційне
                        перевантаження.
                    </p>
                </div>
                <hr class="border-dark">
                <div class="d-flex justify-content-between align-items-center mt-4 mb-3">
                    <h3 class="">
                        Передплата
                    </h3>
                    <div class="custom-switch-control d-flex justify-content-between align-items-center"
                         *ngIf="items.length">
                        <button class="btn btn-sm p-1 toggle-button"
                                [ngClass]="{'highlight': activePlan.id === items[0].id}"
                                (click)="switchPlan(items[0])">{{items[0].frequency === 'monthly' ? 'місячна' : 'річна'}}</button>
                        <i (click)="switchPlan(items[1])" *ngIf="activePlan.id === items[0].id"
                           class="toggle highlight bi bi-toggle-off"></i>
                        <i (click)="switchPlan(items[0])" *ngIf="activePlan.id === items[1].id"
                           class="toggle highlight bi bi-toggle-on"></i>
                        <button class="btn btn-sm p-1 toggle-button"
                                [ngClass]="{'highlight': activePlan.id === items[1].id}"
                                (click)="switchPlan(items[1])">{{items[1].frequency === 'monthly' ? 'місячна' : 'річна'}}</button>
                    </div>
                </div>

                <div class="prices mb-5">
                    <ng-container *ngFor="let item of items; let i=index">
                        <div class="price-item" *ngIf="activePlan.id === items[i].id">
                            <div class="value-wrapper"><span class="currency">₴</span><span
                                    class="value">{{item.value}}</span><span
                                    class="period">/місяць</span></div>
                            <p>{{item.title}}</p>
                        </div>
                    </ng-container>
                    <div *ngIf="activePlan?.frequency !== 'monthly' " class="free_trial_placeholder">
                        Знижка -50%
                    </div>
                </div>
                <div class="mt-5 order_details">
                    <h3 class="mb-3">Деталі оплати</h3>
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            Anima AI &ndash; асистент<br>
                            Нейронауковий трекер тривожності, стресу, вигорання та депресії<br>
                            Персональні рекомендації та інсайти
                        </div>
                        <b class="pl-4" *ngIf="activePlan?.value">
                            {{activePlan?.frequency !== 'monthly' ? activePlan?.value + ' ₴ * 12' : activePlan?.value + ' ₴'}}
                        </b>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between align-items-center">
                        <div></div>
                        <span>Загалом: <b>
                            {{activePlan?.frequency !== 'monthly' ? activePlan?.value  + ' ₴ * 12 місяців': activePlan?.value + ' ₴'}}
                        </b>
                        </span>
                    </div>
                </div>
                <hr>
                <form [formGroup]="form" class="mt-3 mb-3" (ngSubmit)="applyPromo(activePlan)">
                    <label *ngIf="codeApplyed">Застосовано промокод</label>
                    <div class="input-group mb-2 ">
                        <input [disabled]="loading" [formControlName]="'promoCode'" class="form-control mr-2" type="text"
                               placeholder="Ввести промокод"/>
                        <button *ngIf="!codeApplyed" type="submit" class="action-btn hover_action"
                                [disabled]="!isLoggedIn || !form.valid || loading "
                                (click)="applyPromo(activePlan)">
                            Застосувати промо код
                            <app-i-arrow></app-i-arrow>
                        </button>
                        <div *ngIf="loading" class="input-group-append">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                        <small class="applyedIcon" *ngIf="!loading && !error && codeApplyed">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-percent"
                                 viewBox="0 0 16 16">
                                <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0M4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
                            </svg>
                        </small>
                    </div>
                    <div><small class="text-danger" *ngIf="!loading && error">
                        {{error}}
                    </small></div>
                </form>


                <ng-container *ngIf="!isLoggedIn" >
                    <button (click)="login()" class="btn btn-block text-primary text-center justify-content-center">
                        Для продовження, будь ласка, увійдіть у свій акаунт
                    </button>
                </ng-container>
                <button *ngIf="isLoggedIn" type="button" class="w-100 action-btn justify-content-center" [disabled]="loading"
                        (click)="pay(activePlan)">
                    <span>Перейти до оплати</span>
                </button>
            </div>
        </div>
    </div>
</div>


<app-footer></app-footer>
<lib-preloader [loading]="loading"></lib-preloader>
